import getFulfilmentIds from "../../../../../../getFulfilmentIds";
import getFulfilmentType, {
  FULFILMENT_TYPE
} from "../../../../../../getFulfilmentType";
import getAfsA11yFulfilmentString from "./getAfsA11yFulfilmentString";
import getCoreNonPrimaryA11yFulfilmentString from "./getCoreNonPrimaryA11yFulfilmentString";
import getPartnerFulfilsA11yFulfilmentString from "./getPartnerFulfilsA11yFulfilmentString";

const { CORE_PRIMARY, CORE_NON_PRIMARY, AFS, PARTNER_FULFILS } =
  FULFILMENT_TYPE;

const a11yFulfilmentStringGeneratorMap = {
  [CORE_PRIMARY]: () => "",
  [CORE_NON_PRIMARY]: getCoreNonPrimaryA11yFulfilmentString,
  [AFS]: getAfsA11yFulfilmentString,
  [PARTNER_FULFILS]: getPartnerFulfilsA11yFulfilmentString
};

const getA11yFulfilmentString = ({ source, seller }) => {
  const { sourceId, sellerId } = getFulfilmentIds({ source, seller });
  const fulfilmentType = getFulfilmentType({ sourceId, sellerId });

  return a11yFulfilmentStringGeneratorMap[fulfilmentType]({ source, seller });
};

export default getA11yFulfilmentString;
